var map = {
	"./43_banana.mp3": "f70d",
	"./44_pear.mp3": "8f80",
	"./45_cherry.mp3": "65ee",
	"./46_lemon.mp3": "f6bd",
	"./M_Brilliant.mp3": "1614",
	"./M_Excellent.mp3": "1319",
	"./M_Fantastic.mp3": "c05d",
	"./M_Great.mp3": "1bae",
	"./M_Perfect.mp3": "19bc",
	"./M_Think again.mp3": "d78a",
	"./M_Try again.mp3": "7b95",
	"./M_Very good.mp3": "6e27",
	"./M_Well done.mp3": "2648",
	"./M_Work harder.mp3": "05c9",
	"./click.mp3": "13c0",
	"./false.mp3": "3cc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "177d";